import request from './request';

export default {
	getAll(query) {
		return request.get('/app-connections', query);
	}
};



// WEBPACK FOOTER //
// ./src/helpers/chated-client/app-connection.js